import { EqlFieldName } from '@modules/common/constants';
import { FieldNames } from 'v2/core/entities/fields';

export const getEqlFieldFromFieldStringValue = (fieldValue: string): string => {
  switch (fieldValue) {
    // for backwards compatibility, using the old 'FieldNames' type
    case FieldNames.ReviewSentiment:
      return EqlFieldName.UserSentiment;
    case FieldNames.Entity:
      return EqlFieldName.Entity;
    case EqlFieldName.EntityCategory:
      return EqlFieldName.Entity;
    case FieldNames.Reason:
      return EqlFieldName.Reason;
    case FieldNames.Source:
      return EqlFieldName.Source;
    case FieldNames.Language:
      return EqlFieldName.Language;
    case FieldNames.FeedbackRecords:
      return EqlFieldName.FeedbackRecords;
    // for other old values + new EqlField 'field' values
    default:
      return fieldValue;
  }
};
